import React, { SyntheticEvent, useContext, useEffect, useState } from 'react'
import { ThemeProvider } from '@emotion/react'
import styles from '../ErrorDashboard/ErrorDashboard.module.css'
import { FormControl, MenuItem, Tab, Tabs, createTheme } from '@mui/material'
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useForm } from 'react-hook-form';
import DateInputWithForm from '../../components/shared-components/datepicker/DateInputWithForm';
import ToasterWithMessage from '../../components/shared-components/toaster';
import AddTicketsError from '../../components/shared-components/error-dashboard/AddTicketsError';
import SoldTicketsError from '../../components/shared-components/error-dashboard/SoldTicketsError';
import StripePaymentsError from '../../components/shared-components/error-dashboard/StripePaymentsError';
import ScrapeEventError from '../../components/shared-components/error-dashboard/ScrapeEventError';
import { globalContext } from '../../Provider/AppProvider';
import { GET_NOTIFICATIONS } from '../../components/shared-components/notification/api/NotificationQuery';
import { useLazyQuery } from '@apollo/client';
import { StyledSelectDropdownforError, getFormattedDate, oneMonthAgo, roles } from '../../helper';
import StripePayoutError from '../../components/shared-components/error-dashboard/StripePayoutError';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PublishTicketsError from '../../components/shared-components/error-dashboard/PublishTicketsError';
import UserTicketsLog from '../../components/shared-components/error-dashboard/UserTicketsLog';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import AuditLogitixLogs from '../../components/shared-components/auditLogs/AuditLogitixLogs';

const CustomSelect = StyledSelectDropdownforError()

const AuditLogs = () => {

  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const tab=localStorage?.getItem('errorTabIndex');

  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(tempRowsPerPage ? tempRowsPerPage : '') || 10);
  const [currentPage, setCurrentPage] = useState(1);
  const [checking,setChecking]=useState<boolean>(false);
  

  const [auditLogsList,setAuditLogsList] = useState<any>([{}]);

  const [columnTypes, setColumnTypes] = useState('');
 


  const [sortType, setSortType] = useState('desc');
  const [selected, setSelected] = useState<number[]>([]);
  const monthStartDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
  const todayDate = moment().format('YYYY-MM-DD');
  const {error} = ToasterWithMessage();
  const [selectedValue, setSelectedValue] = useState('');
  const date = getFormattedDate(new Date());

  const [getNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempState = {...globalState}
      tempState.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempState.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const tempValue = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempValue.globalSearch.searchtext = "";
      tempValue.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempValue.notification.notificationClicked = false;
      tempValue.notification.tp_id_array=null;
      tempValue.globalSearch.searchtext = "";
      tempValue.notification.text = "";
      tempValue.notification.ticketId =null;
      tempValue.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempValue.error.errorClicked = false;
      tempValue.globalSearch.searchtext = "";
      tempValue.error.text = "";
      tempValue.error.approximateTpArray = null
      tempValue.error.ticketPlacementId = null
      tempValue.error.status =""
    }
    handleGlobalState(tempValue);
    getNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const defaultValues: any = {
    fromDate: monthStartDate,
    toDate: todayDate,
  };

  const { control, setValue,reset } = useForm<any>({
    defaultValues,
    shouldUnregister: false,
  });

  const errorDashboardTheme = createTheme({
    palette: {
      primary: {
        main: "#5D75F8",
      },
    },
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: "Glegoo",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "capitalize",
            padding :"5px 8px" 
          },
        },
      },
    },
  });
  

  /* For get the ManageTicket table headers */
  const GenerateAuditLogsHeadCells = ()=>{
    const id =  ["event_name","league_name","api_type","action","status","ticket_placements","venue","old_listing_price","updated_listing_price","user_name"];
    const labels =["Event Name","League Name","API Type","Action","Status","Ticket Placements,Section,Row, Seat", "Venue","Old Listing Price","Updated Listing Price","User Name"];
    const headCells = id.map((id, index) => ({
        id,
        label: labels[index],
      }));
      return headCells;
}
  
const handleChangeRowsPerPage = (event: any) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setTempRowsPerPage(event.target.value);
  setSelected([]);
  setCurrentPage(1);
};

const handlePageChange = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPage(newPage);
  setSelected([]);
  setChecking(false)
};

  return (
    <ThemeProvider theme={errorDashboardTheme}>
      <div className={styles.errorMainContainer}>
        <div className={styles.errorContainer}>
            <Tabs  
              variant='scrollable'
              scrollButtons={false}
            >
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center",fontWeight:"700", color:"#000000",fontSize:"16px" }}>

                    <span>Super User - Audit Logs</span>
                  </div>
                }
              />
            </Tabs>
        </div>
          <AuditLogitixLogs
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            checking={checking}
            setChecking={setChecking}
            auditLogsList={auditLogsList}
            setAuditLogsList={setAuditLogsList}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            GenerateAuditLogsHeadCells={GenerateAuditLogsHeadCells}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handlePageChange={handlePageChange}
          />
      </div>
    </ThemeProvider>
  );
}

export default AuditLogs;